import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import { ceo1 } from '../../assets/images/company/companyImages';

import S from './CompanyPage.module.css'

const CeoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);

    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="company" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="company" />
        </div>
        <div className='com-content-wrap mt-245 mb-50'>
          <div className='mb-50' style={{minHeight:'650px'}}>
            <img src={ceo1} alt='ceoImg' className={S.comContentImg} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CeoPage;
